/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { moduleKey } from 'app/core/constants/constants';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { MyCustomPaginatorIntl } from 'app/core/services/paginator_service/my-paginator.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import { pickerConfig } from 'assets/picker_config';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { PickerOptions, PickerSelectOptions } from '../data-picker/data-picker.interface';
import { NoteDialogService } from '../notes/note-dialog/note-dialog.service';
import { ParamKey } from '../notes/notes.interface';
import { TabsData } from './multi-module-picker.interface';
import { MultiModulePickerService } from './multi-module-picker.service';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-multi-module-picker',
  templateUrl: './multi-module-picker.component.html',
  styleUrls: ['./multi-module-picker.component.scss'],
  providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }]
})
export class MultiModulePickerComponent implements OnInit, OnChanges {
  @Input() openPicker: boolean = false;
  @Input() module: string = '';
  @Input() moduleUID: string = '';
  @Input() setJobFromQuote: boolean = false;
  @Input() sameModuleCanAccess: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() options: PickerOptions = {
    position: '',
    mode: '',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: false,
    selectOption: PickerSelectOptions.select,
    isFromNote: false
  };
  @Input() filter: any = null;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() allAssociates;
  drawerName: string = 'multiModulePicker';
  viewMode: string = '';
  moduleTabs: any[] = [];
  searchKey: string = '';
  pagination: any = {
    totalRecords: 0,
    pageIndex: 0,
    pageSize: 10
  };
  showSelectedItems: boolean = false;
  associatedModules: any ={};
  eventSearchKey: string = '';
  eventPageIndex: any ={
    'JOB': 0,
    'CUSTOMER': 0,
    'ORGANIZATION': 0,
    'PROPERTY': 0,
    'ESTIMATES': 0,
    'INVOICE': 0,
    'SERVICE_CONTRACTS': 0,
    'ASSETS': 0,
    'REQUEST':0,
    'PROJECT':0
  };
  eventSortBy: string;
  eventSortType: string;
  eventFormReset: boolean = false;
  eventSubmit: boolean = false;
  selectedValue: any[] = [];
  pickerConfig: any = pickerConfig;
  get baseUrl(): any{
    return `${this.dataCollectorService.baseurl()}`;
  }
  dataUrl: any = '';
  allModules = ['JOB','CUSTOMER','ORGANIZATION','PROPERTY','ESTIMATES','INVOICE','SERVICE_CONTRACTS','ASSETS', 'REQUEST','PROJECT'];
  paramKey = ParamKey;
  moduleKey = moduleKey;
  defaultModuleSubscription: Subscription;
  defaultModule: string;
  selectedTab: TabsData;

  constructor(
    private zuperDrawerService: ZuperDrawerService,
    private utilityService: UtilityService,
    private dataCollectorService: DataCollectorService,
    private multiModulePickerService: MultiModulePickerService,
    private noteDialogService: NoteDialogService,
    private _changeDetecRef: ChangeDetectorRef
  ){ }

  ngOnInit(): void {
    this.drawerName = this.drawerName + uuidv4();
  }

  drawerOpenedChanged(isOpened: boolean): void {
    if (isOpened) {
      this.openDataPicker();
    } else {
      this.resetModulePicker();
      this.eventEmitter.emit({ drawerClosed: true });
    }
  }

  resetModulePicker(): void {
    this.moduleTabs = [];
    this.viewMode = '';
    this.selectedValue = [];
    this.defaultModule = null;
  }

  openDataPicker(): void {
    const moduleTabs = this.multiModulePickerService.getTabs() || [];
    _.each(moduleTabs, (tab: TabsData)=>{
      if(this.checkModuleAccess(moduleKey[tab.module]) && (this.module !== tab?.module || this.sameModuleCanAccess)){
        this.moduleTabs.push(tab);
      }
    });
    if(this.moduleTabs?.length > 0){
      this.selectedTab = this.moduleTabs[0];
      this.viewMode = this.selectedTab.dataKey;
      this.selectedTab.customParams = this.selectedTab.customParams || {};
    }
    const associatedModules = this.multiModulePickerService.getAssociatedModules();
    this.associatedModules = {};
    _.each(_.keys(associatedModules), (module: string)=>{
      if(module && associatedModules[module] && associatedModules[module][0] && !(ParamKey[module.toUpperCase()] in this.associatedModules)){
        this.associatedModules[ParamKey[module.toUpperCase()]] = associatedModules[module];
      }
    });
    if(!_.isEmpty(this.associatedModules)){
      this.selectedValue = this.associatedModules[ParamKey[this.viewMode]]??[];
    }
    this.defaultModule = moduleKey[this.multiModulePickerService.getDefaultModule()];
    this.dataUrl = this.baseUrl + this.selectedTab?.dataUrl;
  }

  getHeaderDisplayKey(): string {
    return this.options.header?.displayKey ?? this.options.header?.displayName;
  }

  getFooterDisplayKey(): string {
    return this.options.footer?.displayKey ?? this.options.footer?.displayName;
  }

  changeViewMode(tab: any): any {
    if (this.viewMode !== tab.dataKey) {
      this.viewMode = '';
      this.dataUrl = this.baseUrl + tab.dataUrl;
      this.selectedTab.customParams = this.selectedTab.customParams || {};
      this.eventSortBy = undefined;
      this.eventSortType = undefined;
      this.selectedTab = tab;
      setTimeout(() => {
        this.viewMode = tab.dataKey;
        this.selectedValue = this.associatedModules[ParamKey[this.viewMode]] ?? [];
        this._changeDetecRef.markForCheck();
      });
    }
  }

  setTabClasses(mode: string): any {
    return {
      'border-indigo-500 text-indigo-600': this.viewMode === mode,
      'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': this.viewMode !== mode
    };
  }

  closeDataPicker(): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    drawer?.close();
    this.noteDialogService.onNewAssociationClicked.next(false);
  }

  triggerSearch(searchKey: any): void {
    _.each(this.eventPageIndex, (index: any) => index = 0);
    this.eventSearchKey = searchKey;
  } 

  onPageEvent(event: any): void {
    this.pagination.pageIndex = event.pageIndex;
    this.eventPageIndex[this.viewMode] = this.pagination.pageIndex;
  }

  eventEmitHandler(event: any): void {
    this.updatePickerValues(event);
    const associatedModules = this.multiModulePickerService.getAssociatedModules();
    if(this.setJobFromQuote && this.viewMode === 'ESTIMATES' && event?.value?.length> 0){
      if(event?.value[0]?.job?.job_uid){
        this.associatedModules[ParamKey['JOB']] = [event?.value[0]?.job];
      }else if(associatedModules[ParamKey['JOB']]?.length ){
        this.associatedModules[ParamKey['JOB']] = associatedModules[ParamKey['JOB']];
      }else{
        delete this.associatedModules[ParamKey['JOB']];
      }
    }
    this.associatedModules[ParamKey[this.viewMode]] = event.value ?? this.associatedModules[ParamKey[this.viewMode]];
  }

  updatePickerValues(event): void{
    this.pagination.totalRecords = event.totalRecords ?? this.pagination.totalRecords;
    this.pagination.pageIndex = event.pageIndex ?? this.eventPageIndex[this.viewMode];
    this.searchKey = event.searchKey ?? this.searchKey;
    this.eventSearchKey = event.searchKey ?? this.eventSearchKey;
    this.eventPageIndex[this.viewMode] = event.pageIndex ?? this.eventPageIndex[this.viewMode];
    this.eventSortBy = event.sortBy ?? this.eventSortBy;
    this.eventSortType = event.sortType ?? this.eventSortType;
    if (!this.utilityService.isEmptyOrUndefined(event.showSelectedItems)) {
      this.showSelectedItems = event.showSelectedItems;
    }
    if (!this.utilityService.isEmptyOrUndefined(event.filter)) {
      this.filter = event.filter;
    }
  }

  getAssociatedModuleIcon(module: string): string {
    return ModuleIcon[moduleKey[module]];
  }

  getAssociatedModuleName(module: string, associatedDetails: any): string {
    module = moduleKey[module] ?? module;
        if(!_.isEmpty(associatedDetails)){
            switch(module){
                case 'JOB':
                    return `${associatedDetails?.work_order_number?associatedDetails?.work_order_number+' - ':''}${associatedDetails?.job_title}`;
                case 'CUSTOMER':
                    return `${associatedDetails?.customer_first_name} ${associatedDetails?.customer_last_name ?? ''}`;
                case 'ORGANIZATION':
                    return `${associatedDetails?.organization_name}`;
                case 'PROPERTY':
                    return `${associatedDetails?.property_name}`;
                case 'ESTIMATES':
                case 'ESTIMATE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.estimate_no || ''}`;
                case 'INVOICE':
                    return `${associatedDetails?.prefix?associatedDetails?.prefix+' - ':''}${associatedDetails?.invoice_no || ''}`;
                case 'ASSETS':
                    return `${associatedDetails?.asset_code?associatedDetails?.asset_code+' - ':''}${associatedDetails?.asset_name ?? ''}`;
                case 'REQUEST':
                    return `${associatedDetails?.request_id ? associatedDetails.request_id+' - ':''}${associatedDetails?.request_title ?? ''}`;
                case 'SERVICE_CONTRACT':
                case 'SERVICE_CONTRACTS':
                    return `${associatedDetails.contract_number?associatedDetails.contract_number+' - ':''}${associatedDetails?.contract_name}`;
                case 'PROJECT':
                  return `${associatedDetails?.project_prefix ? (associatedDetails?.project_prefix+' - '):''}${associatedDetails?.project_number ? (associatedDetails.project_number + ' - '): ''}${associatedDetails?.project_name}`;
            }
        }
    }

  checkModuleIsAssociated(module?: any): boolean{
      if(this.associatedModules?.[ParamKey[module]] && this.associatedModules?.[ParamKey[module]].length>0){
          return true;
      }
      else{
          return false;
      }
  }

  updateAssociatedModules(): void{
    //removing modules which has no value/undefined.
    const associatedModules = _.omitBy(this.associatedModules, (value: any) => !value);
    this.multiModulePickerService.associatedModules.next(associatedModules);
    this.closeDataPicker();
  }

  removeAssociatedModule(module, associatedModules): void{
    associatedModules[ParamKey[module]] = undefined;
    if(this.viewMode === module){
      this.selectedValue = [];
    }
  }

  checkModuleAccess(module): boolean{
    return this.utilityService.hasModuleAccess(module, false, 'from_sidebar');
  }

  checkIfModulePresentInTabs(module): boolean{
    return this.moduleTabs.find((tab: TabsData)=> moduleKey[tab.module] === module);
  }

  changeSortType(_event: any): void {
    this.eventSortType = this.eventSortType === 'ASC' ? 'DESC' : 'ASC';
  }

  getSortItemDisplayKey(): string {
    let keyValue: string = '';
    if (this.pickerConfig[moduleKey[this.viewMode]]?.sortItems?.length) {
      const sortItems: any[] = this.pickerConfig[moduleKey[this.viewMode]]?.sortItems;
      sortItems.forEach((item: any) => {
        if (item.actionType === this.eventSortBy) {
          keyValue = item.displayKey ?? item.displayName;
        }
      });
    }
    return keyValue;
  }

  sortMenuClick(item: any): void {
    this.eventSortBy = item.actionType;
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer.open() : this.closeDataPicker();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openPicker?.previousValue !== undefined) {
      this.toggleDrawer(changes?.openPicker.currentValue);
    }
  }
}
